import { FC } from 'react';
import { DocumentType, CalendarResponseDto } from '@/features/calendar/types/calendar-dto';
import CalendarDailyBody from '@/features/calendar/components/CalendarDaily/CalendarDailyBody';
import CalendarDailyHeader from '@/features/calendar/components/CalendarDaily/CalendarDailyHeader';
import CalendarPageEmpty from '@/features/calendar/components/CalendarPageEmpty';

type Props = {
    selectedDate: Date;
    searchText: string;
    setSearchText: (text: string) => void;
    showReservationDetails: (
        id: string,
        type: DocumentType,
        apartmentId?: string,
        checkInDate?: Date,
        checkOutDate?: Date,
    ) => void;
    headerWidth?: string;
} & CalendarResponseDto;

const CalendarDaily: FC<Props> = ({
    apartments,
    selectedDate,
    searchText,
    setSearchText,
    showReservationDetails,
    headerWidth,
}) => {
    return (
        <>
            <div className="relative shrink-0 flex border border-popover-100 rounded-2.5xl overflow-hidden">
                <CalendarDailyHeader
                    apartments={apartments}
                    selectedDate={selectedDate}
                    searchText={searchText}
                    setSearchText={setSearchText}
                    headerWidth={headerWidth}
                />
                <CalendarDailyBody
                    apartments={apartments}
                    selectedDate={selectedDate}
                    showReservationDetails={showReservationDetails}
                />
            </div>
            {!apartments?.length && <CalendarPageEmpty />}
        </>
    );
};

export default CalendarDaily;
